import * as React from "react";
import type { GatsbyBrowser } from "gatsby";
import "./src/styles/global.css";
import { LanguageProvider } from "./src/i18n/LanguageContext";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({
  element,
}) => <LanguageProvider>{element}</LanguageProvider>;
